import type {
  DeclineOrderRequestInput,
  OrderRequestRow,
  PatientDetail,
  RegisterOrderRequestInput,
} from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';

/** Registers the patient a request names, closing the request. */
export function registerFromRequest(
  requestId: number,
  input: RegisterOrderRequestInput,
): Promise<PatientDetail> {
  return api.post<PatientDetail>(ENDPOINT.orderRequestRegister(requestId), input);
}

/** Sends a declined request back to the inbox. */
export function reopenRequest(requestId: number): Promise<OrderRequestRow> {
  return api.post<OrderRequestRow>(ENDPOINT.orderRequestAction(requestId, 'reopen'), {});
}

/** Declines a request, with the reason the requester will be given. */
export function declineRequest(
  requestId: number,
  input: DeclineOrderRequestInput,
): Promise<OrderRequestRow> {
  return api.post<OrderRequestRow>(ENDPOINT.orderRequestAction(requestId, 'decline'), input);
}
